import Page from "components/Page";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { withTranslation } from "react-i18next";
import styles from "./AddBusySlots.module.scss";
import "./AddBusySlots.scss";
import CustomDropdown from "components/Dropdown";
import TimePicker from "rc-time-picker";
import { Row, Col } from "reactstrap";
import Text from "components/Text";
import {
  createBusySlot,
  updateBusySlot,
  useAllActiveOffices,
  useCreateSchedulerEventCheckingAvailabilityMutation,
  useGetBusySlot,
} from "repositories/scheduler-repository";
import { useOfficeDetail } from "repositories/office-repository";
import Loader from "components/Loader";
import moment from "moment";
import {
  scrollToError,
  testRegexCheck,
  testRegexCheckDescription,
  decodeId,
} from "utils";
import { cloneDeep } from "lodash";
import toast from "react-hot-toast";
import ToggleSwitch from "components/ToggleSwitch";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import RepeatEventDropDowns from "accountOwner/pages/AddEvent/RepeatEventDropDowns";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import {
  getSelectedDayValueForWeekdayOrWeekend,
  hasTimeChanged,
  matchedBothDatesValues,
  matchedBothPatternValues,
  MoreTagsFunction,
  setterCustomSchduler,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import SelectOfficeModal from "accountOwner/pages/AddEvent/components/SelectOfficeModal";
import SelectStaffMemberModal from "accountOwner/pages/AddEvent/components/SelectStaffMemberModal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import NewConversationToast from "Messenger/pages/PatientConversation/component/NewConversationToast";
import EditOptionsModal from "accountOwner/pages/EditEvent/EditOptionsModal";
import constants from "../../constants.js";
import { showTime } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab";
import InfoIcon from "assets/images/info_black-tooltip.svg";
import ErrorIcon from "assets/images/ico_alert.svg";
import CircleIcon from "assets/images/check_circle.svg";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const AddBusySlots = ({ t, history, location }) => {
  const {
    selectedId: selectedOwnerId,
    profile,
    getIdToCheckOwnerChange,
  } = useAccountOwnerCommon();
  const state = location?.state || history?.location?.state || {};
  const isDuplicateMode = state?.duplicateBusySlot || false;
  const [selectedOfficeId, setSelectedOfficeId] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [errors, setErrors] = useState({});
  const [eventDate, setEventDate] = useState(null);
  const [repeatType, setRepeatType] = useState(1);
  const [repeatEndDate, setRepeatEndDate] = useState(null);
  const [eventTitle, setEventTitle] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [inProgress, setInProgress] = useState(false);
  const [toggleOn, setToggleOn] = useState(false);
  const [isSaveEmployeeModalOpen, setIsSaveEmployeeModalOpen] = useState(false);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [userIds, setUserIds] = useState([]);
  const [officeIdForNonInvitee, setOfficeIdForNonInvitee] = useState([]);

  const filteredUsers = useMemo(
    () =>
      userIds?.filter(
        (res) =>
          officeIdForNonInvitee?.some(
            (resp) => resp?.officeId === res?.officeId,
          ) ?? true,
      ),
    [officeIdForNonInvitee, userIds],
  );
  let { busySlotId: urlBusySlotId } = useParams();
  // For duplicate mode, get busySlotId from URL but don't use it for edit logic
  const duplicateBusySlotId = isDuplicateMode ? decodeId(urlBusySlotId) : null;
  const busySlotId = isDuplicateMode ? null : decodeId(urlBusySlotId);
  const today = useMemo(
    () => moment(location?.state?.date).toDate() || moment().toDate(),
    [location?.state?.date],
  );

  const CreateSchedulerEventCheckingAvailabilityMutation =
    useCreateSchedulerEventCheckingAvailabilityMutation();
  const [repeatedTypeFrequency, setRepeatedTypeFrequency] = useState(1);
  const [repeatedTypeEvery, setRepeatedTypeEvery] = useState(1);
  const [schedule, setSchedule] = useState([
    today.getDay() === 0 ? 7 : today.getDay(),
  ]);
  const [selectionType, setSelectionType] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState(() => {
    const startOfMonth = moment(today).clone().startOf("month");
    return moment(today).diff(startOfMonth, "weeks") + 1;
  });
  const [selectedDay, setSelectedDay] = useState(
    today.getDay() === 0 ? 7 : today.getDay(),
  );
  const [isDaySwitchOn, setIsDaySwitchOn] = useState(false);
  const [selectedSlotDate, setSelectedSlotDate] = useState([today.getDate()]);
  const [selectedMonths, setSelectedMonths] = useState([today.getMonth() + 1]);
  const [isSelectOfficeModalOpen, setIsSelectOfficeModalOpen] = useState(false);
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });

  const handlePopupToggle = (event, setter) => {
    event.stopPropagation();
    setInvitePopupPosition({
      top: 40,
      left: 40,
    });
    setter((prev) => !prev);
  };

  const repeatOptions = useMemo(
    () => addEditEventsConst.repeatedOptions(t),
    [],
  );
  const [isAllDaySlot, setIsAllDaySlot] = useState(false);

  const {
    isLoading: officeListLoading,
    data: officeList,
    isError,
  } = useAllActiveOffices(1, constants.OFFICE_PAGE_SIZE_100, selectedOwnerId);

  let SchedulerBusySlotDate = moment(
    location?.state?.date || state?.requestedDate,
  ).format("YYYY-MM-DD");
  const { isLoading: officeDetailsLoading, data: officeDetails } =
    useOfficeDetail(selectedOfficeId || officeIdForNonInvitee[0]?.id, {
      enabled: !!(selectedOfficeId || officeIdForNonInvitee[0]?.id),
    });
  // Use duplicateBusySlotId for fetching data in duplicate mode, busySlotId for edit mode
  const actualBusySlotId = isDuplicateMode ? duplicateBusySlotId : busySlotId;
  const { data: busySlot } = useGetBusySlot(
    actualBusySlotId,
    SchedulerBusySlotDate,
    {
      enabled: !!actualBusySlotId,
    },
  );

  const startOrEndTimeValue = useCallback(
    (value, startOrEndTime) => {
      if (isAllDaySlot) {
        return moment(eventDate)
          [startOrEndTime]("day")
          .format("YYYY-MM-DDTHH:mm");
      }
      if (!value) {
        return null;
      }
      return (
        moment(eventDate).format("YYYY-MM-DDT") + moment(value).format("HH:mm")
      );
    },
    [isAllDaySlot, eventDate],
  );
  //for event Date
  const selectedOfficeCurrentDate = useMemo(() => {
    if (location?.state?.date) {
      return today;
    }
    return moment().toDate();
  }, [officeDetails]);

  useEffect(() => {
    // Don't clear times if we have busySlot data (edit or duplicate mode)
    if (!busySlot?.data) {
      setEventDate(selectedOfficeCurrentDate);
      setRepeatEndDate(selectedOfficeCurrentDate);
      setRepeatEndDate(
        moment(selectedOfficeCurrentDate).add(3, "months").toDate(),
      );
      setStartTime(null);
      setEndTime(null);
    }
  }, [selectedOfficeCurrentDate, busySlot?.data]);

  useEffect(() => {
    if (busySlot?.data && typeof busySlot?.data === "object") {
      const res = busySlot?.data;

      // For duplicate mode, check if date is in the past and use today if so
      let dateToUse = res.date
        ? moment(SchedulerBusySlotDate ?? res.date).toDate()
        : null;

      setEventTitle(res.title);
      setRepeatType(res.repeatedType);
      if (dateToUse) {
        setEventDate(dateToUse);
      } else if (res.date) {
        setEventDate(moment(SchedulerBusySlotDate ?? res.date).toDate());
      }
      setEventLocation(res.location);
      setEventDescription(res.description);
      if (res.startTime) {
        setStartTime(moment(res.startTime));
      }
      res.repeatedEndDate &&
        setRepeatEndDate(moment(res.repeatedEndDate).toDate());
      if (res.endTime) {
        setEndTime(moment(res.endTime));
      }
      setSelectedOfficeId(res.officeId);
      setToggleOn(res.isNotifyEmployee);
      setIsAllDaySlot(res?.isAllDayBusy);
      const notifiedUserId = res.busySlotNotifiedUsers || [];
      const officeIds = res?.schedulerBusySlotOffice
        ?.map((office) => {
          return {
            ...office,
            id: office?.office?.id,
            name: office?.office?.name,
            officeImage: office?.office?.officeLogo,
          };
        })
        ?.filter((item) => !item?.isDeletedForThisSchedulerBusySlot);
      setUserIds(notifiedUserId);
      setOfficeIdForNonInvitee(officeIds);
      if (
        res?.repeatedType === addEditEventsConst.repeatedOptionsValues.custom &&
        res?.customRepeatPattern
      ) {
        const values = res?.customRepeatPattern;
        setRepeatedTypeEvery(values.interval);
        setRepeatedTypeFrequency(values.unit);
        if (values?.daysOfMonth?.length) {
          setSelectedSlotDate(values?.daysOfMonth?.map((res) => res.day));
        }
        if (values.unit === 2) {
          setSchedule(values.daysOfWeek.map((res) => res.dayOfWeek));
        }

        if (
          values.unit === addEditEventsConst.repeatOptionsFrequency[2].id &&
          !values.daysOfMonth.length
        ) {
          setSelectionType(false);
        }
        if (
          [
            addEditEventsConst.repeatOptionsFrequency[2].id,
            addEditEventsConst.repeatOptionsFrequency[3].id,
          ].includes(values.unit) &&
          values.daysOfWeek.length
        ) {
          setSelectedDay(
            getSelectedDayValueForWeekdayOrWeekend(
              values.daysOfWeek.map((res) => res.dayOfWeek),
            ),
          );
        }
        if (values?.monthWeekNumber) {
          setSelectedWeek(values?.monthWeekNumber);
        }
        if (values?.monthsOfYear?.length) {
          setSelectedMonths(values.monthsOfYear.map((res) => res.month));
        }
        if (
          values.unit === addEditEventsConst.repeatOptionsFrequency[3].id &&
          values.monthsOfYear.length > 0 &&
          values.daysOfWeek.length > 0
        ) {
          setIsDaySwitchOn(true);
        }
      }
    }
  }, [busySlot, isDuplicateMode, SchedulerBusySlotDate]);

  const goBack = (qry) => {
    if (qry) {
      history.push(constants.routes.scheduler.calendar + (qry ?? ""));
      return;
    }
    history.goBack();
  };
  useEffect(() => {
    if (getIdToCheckOwnerChange()) {
      history.goBack();
    }
  }, [selectedOwnerId]);
  //for office
  let OfficeOptions = [];
  if (!officeListLoading && officeList?.data?.length) {
    OfficeOptions = officeList.data;
  }

  useEffect(() => {
    if (officeList?.data?.length === 1) {
      setSelectedOfficeId(officeList.data[0].id);
    }
  }, [officeList]);

  const handleSelectOffice = (value, errorsData) => {
    setOfficeIdForNonInvitee(value);
    if (!value?.length) {
      errorsData.officeList = t("form.errors.emptySelection", {
        field: t("form.fields.office"),
      });
    } else {
      delete errorsData.officeList;
    }
  };
  // All Day logic: set times when toggled on
  useEffect(() => {
    if (isAllDaySlot) {
      setStartTime(moment(eventDate).startOf("day"));
      setEndTime(moment(eventDate).hour(23).minute(59).second(0));
    }
    // Do not clear times when toggled off; let user control
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllDaySlot, eventDate]);

  const handleStartTime = (value, errorsData) => {
    setStartTime(value);
    if (value) delete errorsData.startTime;
    if (value && endTime) {
      const duration = moment
        .duration(moment(endTime).diff(moment(value)))
        .asMinutes();
      if (duration < 15) {
        setEndTime(moment(value).add(15, "minutes"));
        delete errorsData.endTime;
      }
    }
  };

  const handleEndTime = (value, errorsData) => {
    setEndTime(value);
    if (value) delete errorsData.endTime;
    if (startTime) {
      const duration = moment
        .duration(moment(value).diff(moment(startTime)))
        .asMinutes();
      if (duration < 1) {
        errorsData.endTime = t("form.errors.endTimeShouldBeGreater", {
          min: 1,
        });
      } else {
        delete errorsData.endTime;
      }
    }
  };

  const handleTextField = (
    fieldName,
    value,
    errorsData,
    errorKey,
    errorField,
  ) => {
    const setterMap = {
      eventLocation: setEventLocation,
      eventDescription: setEventDescription,
      eventTitle: setEventTitle,
    };
    setterMap[fieldName](value);

    if (!value.trim().length) {
      errorsData[errorKey] = t("form.errors.emptyField", {
        field: t(errorField),
      });
    } else {
      delete errorsData[errorKey];
    }
  };

  const handleCheckBoxField = (value, errorsData) => {
    setIsAllDaySlot(value);
    if (value) {
      delete errorsData.endTime;
      delete errorsData.startTime;
    }
  };

  const handleChange = (field, value) => {
    let errorsData = cloneDeep(errors);

    switch (field) {
      case "selectOffice":
        handleSelectOffice(value, errorsData);
        break;
      case "startTime":
        handleStartTime(value, errorsData);
        break;
      case "endTime":
        handleEndTime(value, errorsData);
        break;
      case "eventLocation":
        handleTextField(
          "eventLocation",
          value,
          errorsData,
          "eventLocation",
          "location",
        );
        break;
      case "eventDescription":
        handleTextField(
          "eventDescription",
          value,
          errorsData,
          "eventDescription",
          "form.fields.description",
        );
        break;
      case "eventTitle":
        handleTextField("eventTitle", value, errorsData, "eventTitle", "title");
        break;
      case "allDay":
        handleCheckBoxField(value, errorsData);
        break;
      default:
        break;
    }

    setErrors(errorsData);
  };

  const isValidEvent = () => {
    const errorsData = cloneDeep(errors);

    const validateField = (condition, errorKey, errorMessage) => {
      if (condition) {
        errorsData[errorKey] = errorMessage;
      } else {
        delete errorsData[errorKey];
      }
    };

    // Office
    validateField(
      !officeIdForNonInvitee?.length,
      "officeList",
      t("form.errors.emptySelection", { field: t("form.fields.office") }),
    );

    // Title
    validateField(
      !eventTitle.trim().length,
      "eventTitle",
      t("form.errors.emptyField", { field: t("title") }),
    );

    // Start Time
    if (!isAllDaySlot) {
      validateField(
        !startTime,
        "startTime",
        t("form.errors.emptySelection", { field: t("staff.startTime") }),
      );

      // End Time
      validateField(
        !endTime,
        "endTime",
        t("form.errors.emptySelection", { field: t("staff.endTime") }),
      );
    }

    // Start & End Time gap
    if (startTime && endTime) {
      const duration = moment
        .duration(moment(endTime).diff(moment(startTime)))
        .asMinutes();
      validateField(
        duration < 1,
        "endTime",
        t("form.errors.endTimeShouldBeGreater"),
      );
    }

    // Location
    validateField(
      !eventLocation.trim().length,
      "eventLocation",
      t("form.errors.emptyField", { field: t("location") }),
    );

    // Description
    validateField(
      !eventDescription.trim().length,
      "eventDescription",
      t("form.errors.emptyField", { field: t("form.fields.description") }),
    );
    if (repeatType !== addEditEventsConst.repeatedOptionsValues.never) {
      const startDate = moment(eventDate).format("YYYY-MM-DD");
      const endDate = moment(repeatEndDate).format("YYYY-MM-DD");
      validateField(
        !moment(startDate).isBefore(endDate),
        "repeatedEndDate",
        t("form.errors.endGreater"),
      );
    }
    // Employees
    validateField(
      !filteredUsers.length && toggleOn,
      "selectEmployees",
      t("form.errors.emptySelection", { field: t("accountOwner.employees") }),
    );

    setErrors(errorsData);

    const hasErrors = Object.values(errorsData).some((err) => !!err);
    if (hasErrors) scrollToError();

    return !hasErrors;
  };

  let officeIds = (officeIdForNonInvitee || [])
    ?.filter((office) => office?.id)
    ?.map((office) => office?.id);
  const matchUserIds = (matching, matchedWith) => {
    return matching.filter((item) => {
      return (
        !officeIdForNonInvitee?.some(
          (resp) => !resp.IsDeleted && resp.officeId === item.officeId,
        ) ||
        !matchedWith?.some(
          (res) => res.userId === item.userId && res.officeId === item.officeId,
        )
      );
    });
  };
  const matchOfficeIds = (matching, matchedWith, officeIds) => {
    matching.forEach((res) => {
      if (!matchedWith.some((resp) => resp.officeId === res.officeId)) {
        officeIds.push(res.officeId);
      }
    });
  };
  const verifyIfUpdated = () => {
    if (!busySlotId)
      return {
        UpdateFlags: {},
        changedCheck: false,
      };
    const res = busySlot?.data;
    const UpdateFlags = {
      isTitleEdit: false,
      isStartTimeEdit: false,
      isEndTimeEdit: false,
      IsAllDayBusyEdit: false,
      isLocationEdit: false,
      IsDescriptionEdit: false,
      IsOfficeEdit: false,
      IsNotifiedUserEdit: false,
      IsNotifiedStaffListEdit: false,
      IsRepeatTypeChange: repeatedOptionChanged,
      IsBusySlotDateChange: dateChanged.startDateChanged,
      IsRepeatedEndDateChange: dateChanged.endDateChanged,
      OfficeIds: [],
      BusySlotEmployeeView: [],
    };
    UpdateFlags.isTitleEdit = eventTitle.trim() !== res?.title.trim();
    UpdateFlags.isStartTimeEdit = hasTimeChanged(
      res?.startTime,
      startOrEndTimeValue(startTime, "startOf"),
    );
    UpdateFlags.isEndTimeEdit = hasTimeChanged(
      res?.endTime,
      startOrEndTimeValue(endTime, "endOf"),
    );
    UpdateFlags.isAllDayEventEdit = res?.isAllDayBusy !== isAllDaySlot;
    UpdateFlags.isLocationEdit = eventLocation !== res?.location;
    UpdateFlags.IsDescriptionEdit = eventDescription !== res?.description;
    UpdateFlags.IsOfficeEdit =
      officeIdForNonInvitee?.length !== res?.schedulerBusySlotOffice?.length;
    UpdateFlags.IsNotifiedUserEdit = toggleOn !== res?.isNotifyEmployee;
    UpdateFlags.IsNotifiedStaffListEdit =
      userIds?.length !== res?.busySlotNotifiedUsers?.length;
    UpdateFlags.BusySlotEmployeeView =
      res?.busySlotNotifiedUsers?.length > userIds?.length
        ? matchUserIds(res?.busySlotNotifiedUsers, userIds).map((item) => ({
            officeId: item.officeId,
            userId: item.userId || null,
          }))
        : matchUserIds(userIds, res?.busySlotNotifiedUsers).map((item) => ({
            officeId: item.officeId,
            userId: item.userId || null,
          }));
    const offices = [];
    matchOfficeIds(
      res?.schedulerBusySlotOffice,
      officeIdForNonInvitee,
      offices,
    );
    matchOfficeIds(
      officeIdForNonInvitee,
      res?.schedulerBusySlotOffice,
      offices,
    );
    UpdateFlags.OfficeIds = offices;

    return {
      UpdateFlags,
      changedCheck: Object.values(UpdateFlags).some((value) =>
        typeof value === "boolean" ? value : value?.length > 0,
      ),
    };
  };

  const handleBlock = async (value = 0) => {
    const neverCheck =
      busySlot?.data?.repeatedType ===
      addEditEventsConst.repeatedOptionsValues.never;
    const isValidForm = isValidEvent();
    if (!isValidForm) {
      scrollToError();
      return;
    }
    const verified = verifyIfUpdated();
    if (
      busySlotId &&
      !neverCheck &&
      !value &&
      (verified.changedCheck || repeatedOptionChanged)
    ) {
      setEditModalConfirmation(true);
      return;
    }

    if (isValidForm && officeDetails) {
      if (busySlotId && !verified.changedCheck) {
        return goBack();
      }
      let userApiData = userIds?.map((item) => ({
        userid: item?.userId,
        OfficeId: item?.officeId,
      }));
      if (busySlotId) {
        const res = busySlot?.data;
        const check = new Map();
        const values = [];
        const checkStaff = new Map();
        const valuesStaff = [];
        res?.schedulerBusySlotOffice.forEach((element) => {
          check.set(element.officeId, element.officeId);
          const adding = {
            id: element.id,
            SchedulerBusySlotId: element.schedulerBusySlotId,
            OfficeId: element.officeId,
            IsDeleted: false,
          };
          if (
            officeIdForNonInvitee.some(
              (res) => res.officeId === element.officeId,
            )
          ) {
            adding.IsDeleted = false;
          } else {
            adding.IsDeleted = true;
          }
          values.push(adding);
        });

        res?.busySlotNotifiedUsers.forEach((element) => {
          const userId = element?.userId;
          const officeId = element?.officeId;
          const key = `${userId}-${officeId}`;
          checkStaff.set(key);

          const adding = {
            id: element?.id,
            SchedulerBusySlotId: res?.id,
            OfficeId: element?.officeId,
            userid: element?.userId,
            IsDeleted: false,
          };
          if (
            userIds.some(
              (res) =>
                res?.userId === element?.userId &&
                res?.officeId === element?.officeId,
            ) &&
            values?.some(
              (resp) => !resp.IsDeleted && resp.OfficeId === element.officeId,
            )
          ) {
            adding.IsDeleted = false;
          } else {
            adding.IsDeleted = true;
          }

          valuesStaff.push(adding);
        });

        userIds.forEach((ele) => {
          const key = `${ele.userId}-${ele.officeId}`;
          if (!checkStaff.has(key)) {
            valuesStaff.push({
              id: 0,
              SchedulerBusySlotId: res.id,
              OfficeId: ele.officeId,
              userid: ele?.userId,
              IsDeleted: false,
            });
          }
        });
        userApiData = valuesStaff;

        officeIdForNonInvitee.forEach((ele) => {
          if (!check.has(ele.officeId)) {
            values.push({
              id: 0,
              SchedulerBusySlotId: res.id,
              OfficeId: ele.officeId,
              IsDeleted: false,
            });
          }
        });
        officeIds = values;
      } else {
        officeIds = (officeIdForNonInvitee || [])
          ?.filter((office) => office?.id)
          ?.map((office) => office?.id);
        userApiData = userIds?.map((item) => ({
          userid: item?.userId,
          OfficeId: item?.officeId,
        }));
      }
      setInProgress(true);
      const params = {
        OwnerId: officeDetails.ownerId,
        OfficeIds: officeIds || [],
        Title: eventTitle,
        Date: busySlotId
          ? moment(
              SchedulerBusySlotDate &&
                moment(SchedulerBusySlotDate)
                  .startOf("day")
                  .isSame(moment(eventDate).startOf("day"))
                ? busySlot?.data?.date
                : eventDate,
            ).format("YYYY-MM-DDTHH:mm")
          : moment(eventDate).startOf("day").format("YYYY-MM-DDTHH:mm"),
        StartTime: startOrEndTimeValue(startTime, "startOf"),
        EndTime: startOrEndTimeValue(endTime, "endOf"),
        repeatedType: +repeatType,
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        isRepeated: +repeatType > 1,
        repeatedDay: +repeatType === 1 ? null : moment(eventDate).isoWeekday(),
        RepeatedEndDate:
          +repeatType === 1 ? null : moment(repeatEndDate).format("YYYY-MM-DD"),
        Location: eventLocation,
        Description: eventDescription,
        IsNotifyEmployee: toggleOn,
        BusySlotEmployeeView: userApiData || [],
        IsAllDayBusy: isAllDaySlot,
      };
      setterCustomSchduler({
        params,
        repeatedType: repeatType,
        repeatedTypeFrequency,
        repeatedTypeEvery,
        selectionType,
        schedule,
        selectedSlotDate,
        selectedWeek,
        selectedDay,
        selectedMonths,
        isDaySwitchOn,
        edit: busySlotId && !isDuplicateMode ? true : false,
        eventDetail: busySlotId && !isDuplicateMode ? busySlot?.data : {},
      });
      // Only add update params if in edit mode (not duplicate mode)
      if (busySlotId && !isDuplicateMode) {
        params.UpdateFlags = verified.UpdateFlags;
        params.EditType = value || 3;
        params.SchedulerBusySlotId = busySlotId;
        params.RequestedDate = SchedulerBusySlotDate;
        delete params.isRepeated;
      }
      try {
        // In duplicate mode, always call create API
        if (isDuplicateMode) {
          const response = await createBusySlot(params);
          toast.success(t("scheduler.busySlotAdded"));
          setInProgress(false);
          const firstOccurrenceDate =
            response.data?.data?.firstOccurrenceDate ||
            response.data?.firstOccurrenceDate;
          if (firstOccurrenceDate) {
            return goBack(
              `?${showTime}=` + new Date(firstOccurrenceDate).valueOf(),
            );
          }
          goBack();
        } else if (busySlotId) {
          await updateBusySlot(params);
          toast.success(t("scheduler.busySlotUpdated"));
          if (anyChangedForDate) {
            history.replace(constants.routes.scheduler.calendar);
          } else {
            goBack();
          }
        } else {
          const response = await createBusySlot(params);
          toast.success(t("scheduler.busySlotAdded"));
          const firstOccurrenceDate =
            response.data?.data?.firstOccurrenceDate ||
            response.data?.firstOccurrenceDate;
          if (firstOccurrenceDate) {
            return goBack(
              `?${showTime}=` + new Date(firstOccurrenceDate).valueOf(),
            );
          }
          goBack();
        }
        setInProgress(false);
        // return
      } catch (err) {
        toast.error(err.message);
        setInProgress(false);
      }
    }
  };
  let busySlotDetail = busySlot?.data;
  const repeatedOptionChanged = useMemo(() => {
    return matchedBothPatternValues({
      repeatedType: repeatType,
      repeatedTypeFrequency,
      repeatedTypeEvery,
      selectionType,
      schedule,
      selectedSlotDate,
      selectedWeek,
      selectedDay,
      selectedMonths,
      isDaySwitchOn,
      edit: true,
      eventDetail: busySlotDetail,
    });
  }, [
    repeatType,
    busySlotDetail,
    repeatedTypeFrequency,
    repeatedTypeEvery,
    selectionType,
    schedule,
    selectedSlotDate,
    selectedWeek,
    selectedDay,
    selectedMonths,
    isDaySwitchOn,
  ]);
  const dateChanged = useMemo(() => {
    return matchedBothDatesValues({
      eventDetail: busySlotDetail,
      repeatedEndDate: repeatEndDate,
      requestedDate: SchedulerBusySlotDate,
      eventDate,
    });
  }, [eventDate, repeatEndDate, busySlotDetail, SchedulerBusySlotDate]);
  const anyChangedForDate = useMemo(
    () =>
      dateChanged.startDateChanged ||
      dateChanged.endDateChanged ||
      repeatedOptionChanged,
    [repeatedOptionChanged, dateChanged],
  );
  const openEmployeePopUp = () => {
    let errorsData = JSON.parse(JSON.stringify(errors));

    if (officeIdForNonInvitee?.length) {
      setIsSaveEmployeeModalOpen(true);
      delete errorsData["selectEmployees"];
    } else {
      errorsData["selectEmployees"] = t("form.errors.emptySelection", {
        field: t("superAdmin.office"),
      });
    }
    setErrors(errorsData);
    scrollToError();
  };

  const handleToggle = () => {
    setToggleOn(!toggleOn);
  };

  const firstUserName = () => {
    if (filteredUsers?.length === 1) {
      const { firstName, lastName } = userIds[0]?.user ?? {
        firstName: "",
        lastName: "",
      };
      return `${firstName} ${lastName}`;
    } else {
      return `${filteredUsers?.length} ${t("Selected")}`;
    }
  };

  const eventKey = useMemo(
    () => ({
      eventOrShift: t(`accountOwner.busySlot`).toLowerCase(),
    }),
    [],
  );
  const unAuthAndEmptyOffices =
    !officeListLoading &&
    (!OfficeOptions?.length || officeList?.statusCode > 400 || isError);
  const {
    visibilityCardForAvailability,
    conflictingData,
    anyRepeatTypeActive,
    stringValues,
  } = useMemo(() => {
    const anyRepeatTypeActive =
      repeatType !== addEditEventsConst.repeatedOptionsValues.never;
    const conflictingData =
      CreateSchedulerEventCheckingAvailabilityMutation.data;
    return {
      visibilityCardForAvailability:
        (conflictingData || anyRepeatTypeActive) &&
        officeIdForNonInvitee?.length > 0 &&
        (isAllDaySlot || (!isAllDaySlot && startTime && endTime)),
      conflictingData,
      anyRepeatTypeActive,
      stringValues: anyRepeatTypeActive
        ? "warning"
        : conflictingData?.isConflicting
          ? "error"
          : "success",
    };
  }, [
    CreateSchedulerEventCheckingAvailabilityMutation.data,
    officeIdForNonInvitee,
    startTime,
    endTime,
    repeatType,
  ]);

  useEffect(() => {
    if (anyRepeatTypeActive) return;
    if (
      !officeIdForNonInvitee.length ||
      (!isAllDaySlot && (!startTime || !endTime)) ||
      !officeDetails?.ownerId
    )
      return;
    const timer = setTimeout(() => {
      CreateSchedulerEventCheckingAvailabilityMutation.mutate({
        Users: officeIdForNonInvitee.map((res) => ({
          UserId: profile?.id,
          OfficeId: res.officeId,
        })),
        OwnerId: officeDetails?.ownerId,
        IsAllDayEvent: isAllDaySlot,
        EventDate: moment(eventDate).format("YYYY-MM-DD"),
        EventStartTime: startOrEndTimeValue(startTime, "startOf"),
        EventEndTime: startOrEndTimeValue(endTime, "endOf"),
        IsForEvent: false,
        IsForBusySlot: true,
      });
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, [
    officeDetails?.ownerId,
    officeIdForNonInvitee,
    isAllDaySlot,
    startTime,
    endTime,
    anyRepeatTypeActive,
    toggleOn,
    eventDate,
  ]);
  return (
    <Page
      title={
        isDuplicateMode
          ? t("accountOwner.duplicateBusyTimeslots")
          : busySlotId
            ? t("accountOwner.editBusyTimeslots")
            : t("accountOwner.addBusyTimeslots")
      }
      onBack={() => {
        goBack();
      }}
    >
      {(officeListLoading || officeDetailsLoading || inProgress) && <Loader />}
      <div className="mx-auto p-0 container container-smd">
        <Text size="14px" weight="300" color="#000">
          {" "}
          {t("accountOwner.addBusyTimeslotsDesc")}
        </Text>
        <div className="form-wrapper mb-5 margin30">
          {unAuthAndEmptyOffices && (
            <Text size="14px" marginBottom="25px" weight="400" color="red">
              {t("scheduler.noOfficeFoundForBusyslots")}
            </Text>
          )}
          <div className={styles["busy-timeslots-form"]}>
            <div className="c-field">
              <div className={" d-flex justify-content-between "}>
                <label className={styles["c-field-label"]}>
                  <span>{t("Office")}</span>
                </label>
                <span
                  className={`${styles.link_new}${
                    unAuthAndEmptyOffices ? " " + styles["disabled-field"] : ""
                  } link-btn`}
                  onClick={() => {
                    if (unAuthAndEmptyOffices) return;
                    setIsSelectOfficeModalOpen(true);
                  }}
                >
                  {t("Select")}
                </span>
              </div>
              <div
                className="c-form-control"
                style={{
                  position: "relative",
                }}
              >
                {officeIdForNonInvitee?.length === 0 ? (
                  <small>{t("accountOwner.noOfficeSelected")}</small>
                ) : (
                  <MoreTagsFunction
                    value={
                      officeIdForNonInvitee?.filter(
                        (item) => !item?.isDeletedForThisSchedulerBusySlot,
                      ) || []
                    }
                    styles={styles.link_new_btn}
                    lastIndex={2}
                    clickHandler={(e) =>
                      handlePopupToggle(e, setNonInvitePopup)
                    }
                    mapFn={(member) => member?.name}
                  />
                )}

                {nonInvitePopup && (
                  <InviteesPopup
                    position={invitePopupPosition}
                    handleInvitePopupToggle={(e) =>
                      handlePopupToggle(e, setNonInvitePopup)
                    }
                    list={
                      officeIdForNonInvitee?.filter(
                        (item) => !item?.isDeletedForThisSchedulerBusySlot,
                      ) || []
                    }
                    showRoleAndOffice={false}
                    isForEvent={true}
                    onlyOfffice
                  />
                )}
              </div>
              {errors.officeList && (
                <span className="error-msg">{errors.officeList}</span>
              )}
            </div>
            <div className="c-field">
              <label>{t("title")}</label>
              <textarea
                className="c-form-control"
                placeholder={t("form.placeholder1", { field: t("title") })}
                name="title"
                maxLength="400"
                value={eventTitle}
                onChange={(e) =>
                  testRegexCheck(e.target.value) &&
                  handleChange("eventTitle", e.target.value)
                }
              ></textarea>
              {errors.eventTitle && (
                <span className="error-msg">{errors.eventTitle}</span>
              )}
            </div>
            <div className="ch-checkbox c-field all-event-checkbox">
              <label>
                <input
                  type="checkbox"
                  defaultChecked={isAllDaySlot}
                  checked={isAllDaySlot}
                  onChange={(e) => handleChange("allDay", e.target.checked)}
                />
                <span>{t("All Day")}</span>
              </label>
            </div>
            <div className="c-field">
              <label>{t("accountOwner.date")}</label>
              <div className="d-flex inputdate">
                <ReactDatePickerCommon
                  dateFormat="dd-MM-yyyy"
                  className="c-form-control"
                  onChange={(e) => {
                    setEventDate(e);
                    if (!busySlotId) {
                      setRepeatEndDate(moment(e).add(3, "months").toDate());
                    }
                  }}
                  // minDate={new Date()}
                  selected={eventDate || selectedOfficeCurrentDate}
                />
              </div>
            </div>
            <Row>
              <Col xs="6">
                <div className="c-field">
                  <label>{t("start")}</label>
                  <TimePicker
                    showSecond={false}
                    placeholder="--"
                    format="h:mm A"
                    use12Hours
                    onChange={(e) => handleChange("startTime", e)}
                    className={"busy-slot-time-picker"}
                    disabled={isAllDaySlot}
                    value={startTime}
                    minuteStep={1}
                  />
                  {errors.startTime && (
                    <span className="error-msg">{errors.startTime}</span>
                  )}
                </div>
              </Col>
              <Col xs="6">
                <div className="c-field">
                  <label>{t("end")}</label>
                  <TimePicker
                    showSecond={false}
                    placeholder="--"
                    format="h:mm A"
                    use12Hours
                    onChange={(e) => handleChange("endTime", e)}
                    className={"busy-slot-time-picker"}
                    disabled={isAllDaySlot}
                    value={endTime}
                    minuteStep={1}
                  />
                  {errors.endTime && (
                    <span className="error-msg">{errors.endTime}</span>
                  )}
                </div>
              </Col>
            </Row>
            {visibilityCardForAvailability && (
              <div className={`p-3 my-3 cbg-${stringValues}`}>
                <div className="d-flex align-items-start gap-xxs">
                  <img
                    src={
                      anyRepeatTypeActive
                        ? InfoIcon
                        : conflictingData?.isConflicting
                          ? ErrorIcon
                          : CircleIcon
                    }
                    alt="warning icon"
                  />
                  <div>
                    <Text size="12px" weight="500" color="#111B45">
                      {t(`scheduler.${stringValues}MessageForAvailability`)}
                    </Text>
                  </div>
                </div>
              </div>
            )}
            <div className="c-field">
              <label>{t("repeat")}</label>
              <div className="custom-dropdown-only">
                <CustomDropdown
                  options={repeatOptions}
                  selectedOption={repeatType}
                  selectOption={(id) => {
                    setRepeatType(id);
                  }}
                />
              </div>
            </div>
            {busySlotId && anyChangedForDate && (
              <NewConversationToast
                text={t("scheduler.editRepeatEventChangeWarning")}
              />
            )}
            {repeatType === addEditEventsConst.repeatedOptionsValues.custom && (
              <RepeatEventDropDowns
                selectionType={selectionType}
                selectedSlotDate={selectedSlotDate}
                selectedWeek={selectedWeek}
                selectedDay={selectedDay}
                selectedMonths={selectedMonths}
                isDaySwitchOn={isDaySwitchOn}
                repeatedTypeEvery={repeatedTypeEvery}
                repeatedTypeFrequency={repeatedTypeFrequency}
                setSchedule={setSchedule}
                setSelectedMonths={setSelectedMonths}
                setSelectedSlotDate={setSelectedSlotDate}
                schedule={schedule}
                setRepeatedTypeEvery={setRepeatedTypeEvery}
                setRepeatedTypeFrequency={setRepeatedTypeFrequency}
                setSelectionType={setSelectionType}
                setSelectedWeek={setSelectedWeek}
                setSelectedDay={setSelectedDay}
                setIsDaySwitchOn={setIsDaySwitchOn}
                isFromBusySlot={true}
              />
            )}
            {repeatType !== addEditEventsConst.repeatedOptionsValues.never && (
              <div className="c-field">
                <label>{t("accountOwner.busyTimeSlot")}</label>
                <div className="d-flex inputdate">
                  <ReactDatePickerCommon
                    dateFormat="dd-MM-yyyy"
                    className="c-form-control"
                    minDate={eventDate}
                    selected={repeatEndDate || selectedOfficeCurrentDate}
                    onChange={(e) => setRepeatEndDate(e)}
                  />
                </div>
                {errors.repeatedEndDate && (
                  <span className="error-msg">{errors.repeatedEndDate}</span>
                )}
              </div>
            )}

            <div className="c-field">
              <label>{t("location")}</label>
              <textarea
                className="c-form-control"
                placeholder={t("form.placeholder1", { field: t("location") })}
                name="location"
                maxLength="400"
                value={eventLocation}
                onChange={(e) => handleChange("eventLocation", e.target.value)}
              ></textarea>
              {errors.eventLocation && (
                <span className="error-msg">{errors.eventLocation}</span>
              )}
            </div>

            <div className="c-field">
              <label>{t("superAdmin.description")}</label>
              <textarea
                className="c-form-control"
                placeholder={t("form.placeholder1", {
                  field: t("superAdmin.description"),
                })}
                name="Description"
                maxLength="1000"
                value={eventDescription}
                onChange={(e) =>
                  handleChange("eventDescription", e.target.value)
                }
              ></textarea>
              {errors.eventDescription && (
                <span className="error-msg">{errors.eventDescription}</span>
              )}
            </div>
            <div className="c-field">
              <div className="d-flex align-items-center">
                <ToggleSwitch
                  className="mt-0"
                  label="bill-me-later-toggle"
                  value={toggleOn}
                  onChange={handleToggle}
                />
                <div>
                  <Text
                    size="14px"
                    marginBottom="0px"
                    weight="600"
                    className="mr-2 mt-2"
                    color="#2F3245"
                  >
                    {t("accountOwner.notifyEmployee")}
                  </Text>
                  <Text size="12px">
                    {t("accountOwner.timeslotNotifyEmployee")}
                  </Text>
                </div>
              </div>
            </div>
            {toggleOn && (
              <div className="c-field">
                <label className="c-field-label  d-flex justify-content-between">
                  {t("accountOwner.employe")}
                  <span
                    className="link-btn"
                    onClick={() => {
                      openEmployeePopUp();
                    }}
                  >
                    {t("accountOwner.selectEmployees")}
                  </span>
                </label>

                <div className="c-form-control ">
                  <span>
                    {filteredUsers?.length === 0
                      ? t("accountOwner.noEmployeesSelected")
                      : firstUserName()}
                  </span>
                </div>
                {toggleOn &&
                  !filteredUsers.length &&
                  errors.selectEmployees && (
                    <span className="error-msg">{errors.selectEmployees}</span>
                  )}
              </div>
            )}

            <div className="mt-2">
              <button
                className="button button-round button-shadow mr-4 mb-3"
                title={t("accountOwner.blockSlot")}
                onClick={() => handleBlock()}
                disabled={unAuthAndEmptyOffices}
              >
                {t("accountOwner.blockSlot")}
              </button>
              <button
                className="button button-round button-dark button-border"
                title={t("cancel")}
                onClick={() => goBack()}
              >
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      </div>
      {isSaveEmployeeModalOpen && (
        <SelectStaffMemberModal
          isOpen={isSaveEmployeeModalOpen}
          closeStepOneModal={setIsSaveEmployeeModalOpen}
          ownerId={officeDetails?.ownerId}
          setMemberIds={setUserIds}
          memberIds={filteredUsers}
          officeId={officeIds}
          isFromBusySlot={true}
          isFromEditBusySLot={busySlotId ? true : false}
          IsOwnerInclude={true}
        />
      )}
      {!!isSelectOfficeModalOpen && (
        <SelectOfficeModal
          isOpen={!!isSelectOfficeModalOpen}
          closeStepOneModal={setIsSelectOfficeModalOpen}
          ownerId={selectedOwnerId}
          fromSelectOffice={true}
          setMemberIds={(value) => {
            handleChange("selectOffice", value);
          }}
          memberIds={officeIdForNonInvitee}
        />
      )}
      {editModalConfirmation && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={inProgress}
          eventKey={eventKey}
          busySlots={true}
          repeatedOptionChanged={repeatedOptionChanged}
          handleConfirm={(value) => {
            handleBlock(value);
          }}
        />
      )}
    </Page>
  );
};

export default withTranslation()(AddBusySlots);
